import Typography from "../shared/typography";

export function AnalysisPanel({ analysis }: { analysis: string }) {
  return (
    <div className="p-4 border rounded bg-cream">
      <Typography>{analysis}</Typography>
    </div>
  );
}
